import React, { useEffect, useState } from 'react';
import { Search, ArrowLeft, Plus, ArrowRight, Eye,  } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';
import { encryptPayload } from '../utils/encryption';

export default function Recipient() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  // console.log('send money params data', paramsdata);

  const currency = paramsdata?.sendmoneycurrency ?? paramsdata?.currency;
  const transferflowamount = paramsdata?.transferflowamount;
  const currencyid = paramsdata?.currencyid;
  const balance = paramsdata?.balance;
  const buyAmount = paramsdata?.buyAmount;
  const contactId = paramsdata?.contactId;
  const from_currency = paramsdata?.from_currency;
  const from_amount = paramsdata?.from_amount;
  const Nav_node = paramsdata?.Nav_node ?? paramsdata?.sendmoney_Nav_node;
  const exchangeRate = paramsdata?.exchangeRate;
  const nodeType = 'Recipient';
  const transfer_fee = paramsdata?.transfer_fee;
  const service_fee = paramsdata?.service_fee;
  const total_amount = paramsdata?.total_amount;

  const receiveCurrencyValue = currency;

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(buyAmount);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedbeneficiary, setselectedbeneficiary] = useState('');
  const [selectedbeneficiaryCode, setselectedbeneficiaryCode] = useState('');
  const [selectedbeneficiaryBankAccoutNumber, setselectedbeneficiaryBankAccoutNumber] = useState('');
  const [selectedbeneficiaryType, setselectedbeneficiaryType] = useState('');
  const [selectedbeneficiaryId, setselectedbeneficiaryId] = useState('');
  const [selectedbeneficiaryCountry, setselectedbeneficiaryCountry] = useState('');
  const [selectedbeneficiaryBankAccountId, setselectedbeneficiaryBankAccountId] = useState('');
  const [selectedbeneficiaryBeneType, setselectedbeneficiaryBeneType] = useState('');
  const [selectedbeneficiaryBankType, setselectedbeneficiaryBankType] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [, setCountryid] = useState(null);
  const [beneaddress, setBeneaddress] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const sendmoneynode = 7;

  const [balances, setBalances] = useState([]);
  const [usedBalances, setusedBalances] = useState([]);

  const beneficiaryLists = [];

  useEffect(() => {
    getData();
    removeData();
    getBalances();

    if (Nav_node === 2) {
      setBeneficiaries([]);
      beneficiaryList();
    } else {
      beneficiaryList();
    }
  }, [Nav_node]);

  const getBalances = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL + 'API-FX-231-GET-WALLET-BALANCES/' + login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) setBalances(balArray);
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  const getAvailableBalance = (currencyCode) => {
    const balanceObj = balances.find((b) => b.currency === currencyCode);
    if (!balanceObj) return 0;
    const used = usedBalances[currencyCode] || 0;
    const available = parseFloat(balanceObj.balance) - parseFloat(used);
    return available < 0 ? 0 : available;
  };

  const getData = async () => {
    if (transferflowamount != '' && transferflowamount != null) {
      setAmount(transferflowamount);
      sessionStorage.setItem('receive', JSON.stringify(currencyid));
    }
  };

  const removeData = async () => {
    sessionStorage.removeItem('send');
    sessionStorage.removeItem('receive');
  };

  const getClearbankBene = async (token, workspaceId) => {
    const encryptedPayload = await encryptPayload({ workspace_id: workspaceId,platform: 'web',
          extraParamValidation: 'trustedfromweb' });
    await axios
      .post(
        Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      )
      .then((resp) => {
        // console.log('getclearbankresp', resp.data.data);
        resp.data.data.forEach((element) => {
          beneficiaryLists.push({
            id: element.id,
            display_name: element.beneficiaryName,
            bank_account_number: element.banks[0].accountNumber,
            country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
            avatar: '',
            code: element.banks[0].sortCode,
            bank_code_type: 'sort_code',
            type: 'Sort Code',
            country: element.country,
            bank_account_name: '',
            bank_account_id: element.banks[0].id,
            bene_type: element.type,
            bank_type: 'clear_bank',
            currency: element.country == 'GB' ? 'GBP' : element.meta.currency,
          });
        });

        axios
          .get(`${Constants.BASE_URL}API-FX-126-ListBeneficiary`, {
            params: {
              workspace_id: workspaceId,
              reference_type: 'money_transfer',
              country_id: currencyid,
            },
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          })
          .then((response) => {
            response.data.data.forEach((element) => {
              beneficiaryLists.push({
                id: element.id,
                display_name: element.display_name,
                bank_account_number:
                  element.meta.bank_account_number != null && element.meta.bank_account_number != ''
                    ? element.meta.bank_account_number
                    : element.meta.iban,
                country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
                avatar: '',
                code:
                  element.meta.bic_number ??
                  element.meta.aba_number ??
                  element.meta.ifsc_code ??
                  element.meta.aba_number ??
                  element.meta.sort_code ??
                  element.meta.branch_code ??
                  element.meta.bsb_number ??
                  element.meta.routing_code_value_1,
                bank_code_type: 'sort_code',
                type: 'Sort Code',
                country: element.meta.bank_country,
                address: element.meta.beneficiary_address,
                bank_account_name: '',
                bank_account_id: element.id,
                bene_type: element.type,
                bank_type: 'currency_cloud',
              });
            });
            setLoading(false);
          })
          .catch((error) => {
            console.log(error.response);
            setLoading(false);
          });

        setBeneficiaries(beneficiaryLists);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getCCBene = async (token, workspaceId) => {
    try {
      const response = await axios.get(
        `${Constants.BASE_URL}API-FX-126-ListBeneficiary`,
        {
          params: {
            workspace_id: workspaceId,
            reference_type: 'money_transfer',
            country_id: currencyid,
          },
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        },
      );

      const countryCodeMapping = {
        105: 'ifsc_code',
        234: 'aba_number',
        231: 'sort_code',
        38: 'branch_code',
        13: 'bsb_number',
        2: 'iban_number',
        1: 'iban_number',
        55: 'iban_number',
        114: 'iban_number',
        115: 'iban_number',
        129: 'iban_number',
        158: 'iban_number',
        177: 'iban_number',
        198: 'iban_number',
        59: 'iban_number',
        95: 'iban_number',
        100: 'iban_number',
        193: 'iban_number',
        249: 'iban_number',
        130: 'iban_number',
      };

      const beneficiaryLists = response.data.data
        .filter((element) => countryCodeMapping[element.meta.bank_country])
        .map((element) => ({
          id: element.id,
          display_name: element.display_name,
          bank_account_number:
            element.meta.bank_account_number != null && element.meta.bank_account_number != ''
              ? element.meta.bank_account_number
              : element.meta.iban,
          country_flag: element.country_flag,
          avatar: element.avatar,
          code:
            element.meta.bic_number ??
            element.meta.aba_number ??
            element.meta.ifsc_code ??
            element.meta.aba_number ??
            element.meta.sort_code ??
            element.meta.branch_code ??
            element.meta.bsb_number ??
            element.meta.routing_code_value_1,
          bank_code_type: element.meta.bank_code_type,
          type: element.type,
          country: element.meta.beneficiary_address,
          address: element.meta.beneficiary_address,
          countryid: element.meta.bank_country,
          bank_account_name: element.meta.bank_account_name,
          bank_account_id: '',
          bene_type: element.type,
          bank_type: 'currency_cloud',
          currency: element.country == 'GB' ? 'GBP' : element.meta.currency,
          payment_type: element.meta.payment_type,
        }));
      // console.log('getccbene', response.data.data);

      setBeneficiaries((beneficiaries) => [...beneficiaries, beneficiaryLists]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const beneficiaryList = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('login_token');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');

    if (!token || !workspaceId) {
      setLoading(false);
      return;
    }

    if (currencyid == 231) {
      await getClearbankBene(token, workspaceId);
      await getCCBene(token, workspaceId);
    } else {
      await getCCBene(token, workspaceId);
    }
  };

  const toggleBeneficiarySelection = async (
    display_name,
    code,
    bank_account_number,
    type,
    beneficiaryid,
    country,
    bank_account_id,
    bene_type,
    bank_type,
    countryid,
    countryName,
    address,
  ) => {
    if (selectedbeneficiaryId === beneficiaryid) {
      setselectedbeneficiary('');
      setselectedbeneficiaryCode('');
      setselectedbeneficiaryBankAccoutNumber('');
      setselectedbeneficiaryType('');
      setselectedbeneficiaryId('');
      setselectedbeneficiaryCountry('');
      setselectedbeneficiaryBankAccountId('');
      setselectedbeneficiaryBeneType('');
      setselectedbeneficiaryBankType('');
      setCountryid('');
      setselectedbeneficiaryCountry('');
      setBeneaddress('');
    } else {
      setselectedbeneficiary(display_name?.toUpperCase());
      setselectedbeneficiaryCode(code);
      setselectedbeneficiaryBankAccoutNumber(bank_account_number);
      setselectedbeneficiaryType(type);
      setselectedbeneficiaryId(beneficiaryid);
      setselectedbeneficiaryCountry(country);
      setselectedbeneficiaryBankAccountId(bank_account_id);
      setselectedbeneficiaryBeneType(bene_type);
      setselectedbeneficiaryBankType(bank_type);
      setCountryid(countryid);
      setselectedbeneficiaryCountry(countryName);
      setBeneaddress(address);
    }
  };

  const proceedToPay = async (e) => {
    e.stopPropagation();
    const Enteramount = parseFloat(amount);
    if (Enteramount == 0 || Enteramount == '' || Enteramount == null) {
      toast.error('Please enter a valid amount');
    } else {
      let balanceValue = balance;
      if (typeof balanceValue === 'string')
        balanceValue = balanceValue.split(',').join('');
      balanceValue = parseFloat(balanceValue).toFixed(2);

      navigate('/payment-method', {
        state: {
          name: selectedbeneficiary,
          ifsc: selectedbeneficiaryCode,
          code: selectedbeneficiaryCode,
          Node: 'node_2',
          account: selectedbeneficiaryBankAccoutNumber,
          type: selectedbeneficiaryType,
          id: selectedbeneficiaryId,
          bank_account_name: selectedbeneficiary,
          currencyid: currencyid,
          currency: currency,
          amount: amount,
          bank_account_id: selectedbeneficiaryBankAccountId,
          country: selectedbeneficiaryCountry,
          bene_type: selectedbeneficiaryBeneType,
          bank_type: selectedbeneficiaryBankType,
          contactId: contactId,
          exchangeRate: exchangeRate,
          from_currency: from_currency,
          total_amount: total_amount,
          from_amount:from_amount,
          transfer_fee: transfer_fee,
          service_fee: service_fee,
          address: beneaddress,
        },
      });
    }
  };

  const getInitials = (name) => {
    if (!name) return '??';
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) return nameParts[0].substring(0, 2).toUpperCase();
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  };

  const getBeneficiariesList = () => {
    if (currencyid == 231) return beneficiaries;
    return Array.isArray(beneficiaries[0]) ? beneficiaries[0] : [];
  };

  const allFilteredBeneficiaries = getBeneficiariesList().filter(
    (beneficiary) => {
      if (!searchQuery) return true;
      const query = searchQuery.toLowerCase();
      return (
        beneficiary.display_name?.toLowerCase().includes(query) ||
        beneficiary.bank_account_number?.toLowerCase().includes(query) ||
        beneficiary.code?.toLowerCase().includes(query)
      );
    },
  );

  const totalPages = Math.ceil(allFilteredBeneficiaries.length / itemsPerPage);
  const paginatedBeneficiaries = allFilteredBeneficiaries.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const addRecipientState = {
    currency: currency,
    currencyid: currencyid,
    balance: receiveCurrencyValue
      ? getAvailableBalance(receiveCurrencyValue).toLocaleString()
      : '-',
    transferflowamount: amount,
    nodeType: nodeType,
    sendmoneynode: sendmoneynode,
    buyAmount: buyAmount,
    exchangeRate: exchangeRate,
    contactId: contactId,
    from_currency: from_currency,
    total_amount: total_amount,
    from_amount:from_amount,
    sendmoney_Nav_node: 2,
    transfer_fee: transfer_fee || 0,
    service_fee: service_fee || 0,
  };

  const avatarColors = [
    { bg: '#EBF3FF', text: '#1A6FD4' },
    { bg: '#E8F5E9', text: '#2E7D32' },
    { bg: '#FFF3E0', text: '#E65100' },
    { bg: '#F3E5F5', text: '#6A1B9A' },
    { bg: '#E0F2F1', text: '#00695C' },
  ];

  const getAvatarColor = (name) => {
    if (!name) return avatarColors[0];
    const idx = name.charCodeAt(0) % avatarColors.length;
    return avatarColors[idx];
  };


  const PaginationControls = ({ totalPages: tp }) => {
    const getPages = () => {
      if (tp <= 3) return Array.from({ length: tp }, (_, i) => i + 1);
      if (currentPage === 1) return [1, 2, 3];
      if (currentPage === tp) return [tp - 2, tp - 1, tp];
      return [currentPage - 1, currentPage, currentPage + 1];
    };

    const pages = getPages();

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 6,
          padding: '12px 24px',
          borderTop: '1px solid #F2F4F7',
        }}
      >
        <button
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          disabled={currentPage === 1}
          style={{
            width: 32,
            height: 32,
            borderRadius: 6,
            border: '1px solid #E6E5E5',
            background: '#FFFFFF',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            opacity: currentPage === 1 ? 0.4 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18l-6-6 6-6"
              stroke="#1D2338"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {pages[0] > 1 && (
          <>
            <button
              onClick={() => setCurrentPage(1)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 6,
                border: '1px solid #E6E5E5',
                background: '#FFFFFF',
                color: '#1D2338',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              1
            </button>
            {pages[0] > 2 && (
              <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>
            )}
          </>
        )}

        {pages.map((page) => (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            style={{
              width: 32,
              height: 32,
              borderRadius: 6,
              border: '1px solid',
              borderColor: currentPage === page ? '#0B214E' : '#E6E5E5',
              background: currentPage === page ? '#0B214E' : '#FFFFFF',
              color: currentPage === page ? '#FFFFFF' : '#1D2338',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {page}
          </button>
        ))}

        {pages[pages.length - 1] < tp && (
          <>
            {pages[pages.length - 1] < tp - 1 && (
              <span style={{ fontSize: 13, color: '#9CA3AF' }}>...</span>
            )}
            <button
              onClick={() => setCurrentPage(tp)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 6,
                border: '1px solid #E6E5E5',
                background: '#FFFFFF',
                color: '#1D2338',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {tp}
            </button>
          </>
        )}

        <button
          onClick={() => setCurrentPage((p) => Math.min(tp, p + 1))}
          disabled={currentPage === tp}
          style={{
            width: 32,
            height: 32,
            borderRadius: 6,
            border: '1px solid #E6E5E5',
            background: '#FFFFFF',
            cursor: currentPage === tp ? 'not-allowed' : 'pointer',
            opacity: currentPage === tp ? 0.4 : 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18l6-6-6-6"
              stroke="#1D2338"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  };
  PaginationControls.propTypes = {
    totalPages: PropTypes.number,
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] flex justify-center items-start py-8 px-4">
      <ToastContainer />
      <div className="w-full max-w-[680px]">

        <div className="flex items-center mb-5 justify-between">
          <button
            onClick={() => navigate('/SendMoneyTab',{
              state:{
                amount:from_amount,            
                buyAmount:amount,               
                currency,                
                currencyid,               
                exchangeRate,
                contactId,
                from_currency,            
                from_amount,
                transfer_fee,
                service_fee,
                total_amount,
              }
            })}
            className="flex mt-2.5 items-center gap-1 text-[#1f2a44] font-bold text-[18px]  hover:opacity-70 transition"
          >
            <ArrowLeft className="w-5 h-5" />
            Back
          </button>

          <h2 className="text-[20px] font-bold text-[#111827] tracking-tight">
            Select Beneficiary
          </h2>

          <button
            className="flex items-center gap-1.5 bg-[#0B214E] hover:bg-[#0a1c42] transition text-white text-sm mr-1 font-semibold px-4 py-2.5 rounded-lg shadow-sm"
            onClick={() => navigate('/BeneficiaryTypes', { state: addRecipientState })}
          >
            <Plus className="w-4 h-4" />
            Add Beneficiary
          </button>
        </div>

        <div className="mb-4">
          <div className="flex items-center bg-white border border-[#E5E7EB] rounded-xl px-4 py-3 shadow-sm focus-within:border-blue-400 focus-within:ring-2 focus-within:ring-blue-100 transition">
            <Search className="w-4 h-4 text-gray-400 shrink-0" />
            <input
              type="text"
              placeholder="Search beneficiary by name, AccountNumber  etc..."
              className="ml-3 w-full bg-transparent outline-none text-sm text-gray-600 placeholder-gray-400"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#E5E7EB] overflow-hidden">
          {loading ? (
            <div className="text-center py-14">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
              <p className="mt-4 text-gray-500 text-sm">Loading beneficiaries...</p>
            </div>
          ) : paginatedBeneficiaries && paginatedBeneficiaries.length > 0 ? (
            <>
              <div className="px-5 pt-5 pb-3">
                <span className="text-sm font-semibold text-[#374151]">
                  Saved Beneficiaries ({allFilteredBeneficiaries.length})
                </span>
              </div>

              {/* List */}
              <div className="px-4 pb-2">
                {paginatedBeneficiaries.map((beneficiary, index) => {
                  const isSelected = selectedbeneficiaryId === beneficiary.id;
                  const countrieslist =
                    JSON.parse(sessionStorage.getItem('countries')) || [];
                  const matchedCountry = countrieslist.find(
                    (c) => c.id === beneficiary.countryid,
                  );
                  const countryName = matchedCountry?.name;
                  const avatarColor = getAvatarColor(beneficiary.display_name);

                  return (
                    <div
                      key={index}
                      className={`flex items-center justify-between px-4 py-3.5 mb-2 rounded-xl cursor-pointer transition-all duration-150
                        ${isSelected
                          ? 'bg-[#EBF3FF] border border-[#3B82F6]'
                          : 'bg-white border border-[#E5E7EB] hover:border-[#93C5FD] hover:bg-[#F8FBFF]'
                        }`}
                      onClick={() =>
                        toggleBeneficiarySelection(
                          beneficiary.display_name,
                          beneficiary.code,
                          beneficiary.bank_account_number,
                          beneficiary.type,
                          beneficiary.id,
                          beneficiary.country,
                          beneficiary.bank_account_id,
                          beneficiary.bene_type,
                          beneficiary.bank_type,
                          beneficiary.countryid,
                          countryName,
                          beneficiary.address,
                        )
                      }
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <div
                          className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold"
                          style={{
                            backgroundColor: isSelected ? '#3B82F6' : avatarColor.bg,
                            color: isSelected ? '#fff' : avatarColor.text,
                          }}
                        >
                          {getInitials(beneficiary.display_name)}
                        </div>

                        <div className="min-w-0">
                          {/* Name and country — no comma, wider gap */}
                          <div className="flex items-center gap-3">
                            <span className={`text-sm font-semibold ${isSelected ? 'text-[#1D4ED8]' : 'text-[#111827]'}`}>
                              {beneficiary.display_name}
                            </span>
                            {countryName && (
                              <span className="text-xs text-gray-400 font-medium">
                                {countryName}
                              </span>
                            )}
                          </div>
                          <p className="text-xs text-gray-400 mt-0.5 truncate">
                            {beneficiary.bank_account_number}
                            {beneficiary.code ? ` (${beneficiary.code})` : ''}
                          </p>
                        </div>
                      </div>

                      <button
                        className="flex-shrink-0 w-9 h-9 flex items-center justify-center border border-[#E5E7EB] rounded-lg bg-white hover:border-[#0B214E] transition ml-3"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate('/SendMoneyBeneficairyDetail', {
                            state: {
                              beneficiary,
                              country: beneficiary.country,
                              balance,
                              currency_type: beneficiary.currency ?? currency,
                              transfer_fee: transfer_fee,
                              service_fee: service_fee,
                            },
                          });
                        }}
                      >
                        <Eye className="w-4 h-4 text-[#6B7280]" />
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* {totalPages > 1 && (
                <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-[#F3F4F6]">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-[#374151] border border-[#E5E7EB] rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
                  >
                    <ChevronLeft className="w-3.5 h-3.5" />
                    Previous
                  </button>

                  <span className="w-8 h-8 flex items-center justify-center text-xs font-semibold rounded-lg bg-[#3B82F6] text-white shadow-sm">
                    {currentPage}
                  </span>

                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-[#374151] border border-[#E5E7EB] rounded-lg hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition"
                  >
                    Next
                    <ChevronRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              )} */}
              {totalPages > 1 && <PaginationControls totalPages={totalPages} />}
            </>
          ) : (
            <div className="text-center py-14 px-6">
              <p className="text-gray-500 text-sm mb-3">No beneficiaries found</p>
              <button
                className="text-blue-600 font-semibold text-sm hover:underline"
                onClick={() => navigate('/BeneficiaryTypes', { state: addRecipientState })}
              >
                Add your first beneficiary
              </button>
            </div>
          )}
        </div>

        <div className="mt-5">
          <button
            onClick={selectedbeneficiary ? proceedToPay : undefined}
            disabled={!selectedbeneficiary}
            className={`w-full py-4 rounded-xl text-white text-base font-bold flex items-center justify-center gap-3 shadow-md transition-all duration-200
              ${selectedbeneficiary
                ? 'bg-[#D26521] hover:bg-orange-700 cursor-pointer'
                : 'bg-[#9CA3AF] cursor-not-allowed opacity-80'
              }`}
          >
            Proceed
            <ArrowRight className="w-5 h-5 -ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
}